<script>
    export let status = "404";
    export let message = "Page not found";
</script>

<h2>{message}</h2>
<p>{status}</p>